import styled from 'styled-components';
import { PricingPlan } from 'types';


export const CardContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  display: flex;
  flex-direction: column;
`;

export const PlanTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 8px;
`;

export const PlanPrice = styled.p`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const FeatureList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 16px 0;
  flex-grow: 1;
`;

export const FeatureItem = styled.li`
  margin-bottom: 8px;
  &:before {
    content: '✓';
    color: green;
    margin-right: 8px;
  }
`;

export const ActionButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: auto;

  &:hover {
    background-color: #0056b3;
  }
`;


export const PricingPlanCard = ({ plan, onSelect }: { plan: PricingPlan; onSelect: (planId: string) => void }) => {
    return (
        <CardContainer>
            <PlanTitle>{plan.name}</PlanTitle>
            <PlanPrice>{plan.description}</PlanPrice>
            <FeatureList>
                {plan.benefits.map((benefit, index) => (
                    <FeatureItem key={index}>{benefit}</FeatureItem>
                ))}
            </FeatureList>
            <ActionButton onClick={() => onSelect(String(plan.id))}>Select Plan</ActionButton>
        </CardContainer>
    );
};
export const PricingPlanContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;
